var map = {
	"./NLlog.png": 14,
	"./Team1.jpg": 15,
	"./cta-illustration.svg": 54,
	"./feature-tile-icon-01.svg": 55,
	"./feature-tile-icon-02.svg": 56,
	"./feature-tile-icon-03.svg": 57,
	"./feature-tile-icon-04.svg": 58,
	"./feature-tile-icon-05.svg": 59,
	"./feature-tile-icon-06.svg": 60,
	"./illustration-section-01.svg": 61,
	"./illustration-section-02.svg": 62,
	"./logo.svg": 63,
	"./modern-editor-1A.png": 16,
	"./modern-editor-2A.png": 17,
	"./modern-editor-3A.png": 18,
	"./modern-editor-4A.png": 19,
	"./modern-reader-1A.png": 64,
	"./modern-reader-2A.png": 65,
	"./modern-reader-3A.png": 66,
	"./modern-reader-4A.png": 67,
	"./video-placeholder.jpg": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;